import { getReducerErrorMessage, isEmpty } from 'src/utils/helpers'

const initialState = {
  isGetContactDetailsInProgress: false,
  getContactDetailsResponse: {},
  companyData: {},
  otherBranches: [],
  csr: {},
  workingHours: [],
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'GET_CONTACT_DETAILS': {
      return {
        ...state,
        isGetContactDetailsInProgress: true,
        getContactDetailsResponse: {},
      }
    }
    case 'GET_CONTACT_DETAILS_COMMIT': {
      return {
        ...state,
        isGetContactDetailsInProgress: false,
        getContactDetailsResponse: {
          success: true,
        },
        companyData: !isEmpty(action.payload.companyData) ? action.payload.companyData : initialState.companyData,
        otherBranches: !isEmpty(action.payload.otherBranches) ? action.payload.otherBranches : initialState.otherBranches,
        csr: !isEmpty(action.payload.csr) ? action.payload.csr : initialState.csr,
        workingHours: !isEmpty(action.payload.workingHours) ? action.payload.workingHours : initialState.workingHours,
      }
    }
    case 'GET_CONTACT_DETAILS_ROLLBACK': {
      return {
        ...state,
        isGetContactDetailsInProgress: false,
        getContactDetailsResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    default: {
      return state
    }
  }
}
